import React from 'react'
import styles from './know.module.css'

const Know = () => {
  return (
    <div id="Know" className={styles.know}>
      <div className={styles.KnowContainer}>
        {/* Hero Section - Imagen con título superpuesto */}
        <div className={styles.heroSection}>
          <div className={styles.imageContainer}>
            <img 
              src={`${process.env.PUBLIC_URL}/Know.jpg`}
              alt="Know QS - Servicios de Logística Terrestre"
              className={styles.KnowImage}
              loading="lazy" // Mejora la carga en móviles
              onError={(e) => {
                console.error('❌ Error cargando imagen Know.jpg');
                console.log('Ruta esperada:', `${process.env.PUBLIC_URL}/Know.jpg`);
                console.log('Verifica que Know.jpg esté en la carpeta public/');
              }}
              onLoad={() => {
                console.log('✅ Imagen Know.jpg cargada correctamente');
              }}
            />
            {/* Título superpuesto sobre la imagen */}
            <div className={styles.textOverlay}>
              <h1 className={styles.heroTitle}>Did you know?</h1>
            </div>
          </div>
        </div>

        {/* Contenido principal de información */}
        <div className={styles.contentSection}>
          {/* Introducción sin el título principal */}
          <div className={styles.introSection}>
            <h2 className={styles.sectionTitle}>El Servicio Terrestre en México</h2>
            <p className={styles.introText}>
              El servicio terrestre en México es fundamental para la economía y el desarrollo del país 
              por varias razones clave. En QS Logistics entendemos y damos la importancia a todos y 
              cada uno de nuestros servicios, garantizando una atención personalizada a cada uno de 
              nuestros clientes.
            </p>
          </div>

          {/* Puntos clave */}
          <div className={styles.keyPointsSection}>
            <div className={styles.keyPoint}>
              <div className={styles.pointNumber}>01</div>
              <div className={styles.pointContent}>
                <h3 className={styles.pointTitle}>Conectividad Nacional</h3>
                <p className={styles.pointDescription}>
                  México tiene una geografía extensa y diversa, con múltiples polos industriales y 
                  zonas agrícolas. El transporte terrestre permite conectar de forma eficaz:
                </p>
                <ul className={styles.pointList}>
                  <li>Centros de producción con centros de consumo</li>
                  <li>Puertos marítimos con el interior del país</li>
                  <li>Fronteras internacionales (EE.UU. y Guatemala/Belice) con el resto del territorio</li>
                </ul>
              </div>
            </div>

            <div className={styles.keyPoint}>
              <div className={styles.pointNumber}>02</div>
              <div className={styles.pointContent}>
                <h3 className={styles.pointTitle}>Comercio Internacional</h3>
                <p className={styles.pointDescription}>
                  México es una de las economías más abiertas del mundo, con tratados como el T-MEC. 
                  El transporte terrestre:
                </p>
                <ul className={styles.pointList}>
                  <li>Es el principal medio para exportaciones e importaciones con Estados Unidos 
                      (más del 80% del comercio)</li>
                  <li>Conecta zonas industriales con los cruces fronterizos</li>
                </ul>
              </div>
            </div>

            <div className={styles.keyPoint}>
              <div className={styles.pointNumber}>03</div>
              <div className={styles.pointContent}>
                <h3 className={styles.pointTitle}>Flexibilidad y Rapidez</h3>
                <p className={styles.pointDescription}>
                  El transporte terrestre ofrece ventajas únicas:
                </p>
                <ul className={styles.pointList}>
                  <li>Flexibilidad de rutas y horarios</li>
                  <li>Entregas puerta a puerta</li>
                  <li>Ideal para entregas "just in time"</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Modalidades de transporte */}
          <div className={styles.modalitiesSection}>
            <h2 className={styles.sectionTitle}>Modalidades de Transporte Terrestre</h2>
            
            <div className={styles.modalitiesGrid}>
              <div className={styles.modalityCard}>
                <h4 className={styles.modalityTitle}>Carga General</h4>
                <p className={styles.modalityDesc}>Mercancía paletizada, en cajas, etc.</p>
              </div>
              
              <div className={styles.modalityCard}>
                <h4 className={styles.modalityTitle}>Carga Intermodal</h4>
                <p className={styles.modalityDesc}>Contenedores para máxima eficiencia</p>
              </div>
              
              <div className={styles.modalityCard}>
                <h4 className={styles.modalityTitle}>Carga Especializada</h4>
                <p className={styles.modalityDesc}>Refrigerada, materiales peligrosos, sobredimensionada</p>
              </div>
            </div>

            <div className={styles.vehiclesSection}>
              <h3 className={styles.subsectionTitle}>Vehículos Más Comunes</h3>
              <div className={styles.vehiclesList}>
                <span className={styles.vehicleItem}>Tractocamiones (tráiler o quinta rueda)</span>
                <span className={styles.vehicleItem}>Camiones de carga ligera y mediana</span>
              </div>
            </div>
          </div>

          {/* Conclusión y llamada a la acción */}
          <div className={styles.conclusionSection}>
            <div className={styles.conclusionContent}>
              <h3 className={styles.conclusionTitle}>Nuestra Experiencia al Servicio de su Negocio</h3>
              <p className={styles.conclusionText}>
                El transporte terrestre en México no solo conecta puntos geográficos, sino que también 
                integra sectores económicos, facilita el comercio y sostiene el crecimiento del país. 
                En QS Logistics somos expertos y podemos adherirnos a los distintos requerimientos, 
                ofreciendo costos competitivos, garantizando la eficacia en las rutas y brindando un 
                seguimiento oportuno en cada servicio.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Know